import Plyr from 'plyr';

const audio = document.querySelector('.podcast-player__audio');
if (audio) {
    new Plyr(audio);
}
